﻿export const getAddress = async ({
                                     zipcode,
                                     houseNumber,
                                     streetFieldRole,
                                     cityFieldRole,
                                     url = '/Account/AdresOphalen',
                                     signal = null,
                                 } = {}) => {
    
    const setValueAndNotify = (input, value) => {
        if (!input || input.value === value) return;

        input.value = value;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));

        if (window.jQuery?.validator && window.jQuery(input).valid) {
            window.jQuery(input).valid();
        }
    };

    if (!zipcode || !houseNumber || !streetFieldRole || !cityFieldRole) {
        return;
    }
    
    const streetInput = document.querySelector(`[data-role="${streetFieldRole}"]`);
    const cityInput = document.querySelector(`[data-role="${cityFieldRole}"]`);

    if (!streetInput || !cityInput) {
        return;  
    } 

    let response;

    try {
        response = await fetch(url, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                postcode: zipcode,
                huisnummer: String(houseNumber),
            }),
            signal,
        });
    } catch (error) {
        // AbortError is expected when the caller cancels a stale request — not a real failure.
        if (error?.name === 'AbortError') return;
        return false;
    }

    if (!response.ok) {
        return false;
    }
    
    const data = await response.json();
    const found = data.found ?? data.Found ?? false;
    
    if (found) {
        setValueAndNotify(streetInput, data.streetname ?? data.Streetname ?? '');
        setValueAndNotify(cityInput, data.city ?? data.City ?? '');
        return true;
    }

    setValueAndNotify(streetInput, '');
    setValueAndNotify(cityInput, '');

    // Bij lookup failure moet de gebruiker handmatig kunnen invullen.
    streetInput.readOnly = false;
    cityInput.readOnly = false;
    streetInput.removeAttribute('aria-readonly');
    cityInput.removeAttribute('aria-readonly');
};